import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  useEffect(() => {
    document.title = "Page Not Found — GitHub Finder";
  }, []);

  return (
    <div className="not-found fade-in">
      <h1>404</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to="/" className="btn" style={{ marginTop: "1.5rem" }}>
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
